import React, { Component } from 'react'
import LoanDetailUI from './LoanDetailUI.js'
import CacheManager from '../../../cache/CacheManager.js'
import CacheKeys from '../../../cache/CacheKeys.js'

class LoanDetailSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loanList: [],
      statusUpdateMode: false,
      disburseMode: false,
      amountUpdateMode: false,
      promoterFundWaived: false,
      updateLoanMode: false,
      updateDepositMode: false,
      assignedUserMode: false,
      loanPurposeUpdated: false,
      parentLoanUpdated: false,
      lenderUpdateMode: false,
      closedDateUpdateMode: false,
      closedReasonUpdateMode: false,
      requestDescUpdateMode: false
    }
  }

  render() {
    return (
      <LoanDetailUI
        loan={this.props.loan}
        account={this.props.account}
        context={this.props.context}
        bankAccountList={this.props.bankAccountList}
        loanList={this.state.loanList}
        onRefreshClick={this.props.onRefreshClick}
        copyToClipboardText={this.props.copyToClipboardText}
        onCopyToClipboard={this.props.onCopyToClipboard}
        //
        statusUpdateMode={this.state.statusUpdateMode}
        onStatusUpdateClick={this.onStatusUpdateClick}
        onStatusCancelClick={this.onStatusCancelClick}
        //
        onMarkSanctionSigned={this.props.onMarkSanctionSigned}
        enableMarkSanctionSigned={this.props.enableMarkSanctionSigned}
        onEnableMarkSanctionSigned={this.props.onEnableMarkSanctionSigned}
        markSanctionSignedSubmitted={this.props.markSanctionSignedSubmitted}
        markSanctionSignedErrorList={this.props.markSanctionSignedErrorList}
        //
        disburseMode={this.state.disburseMode}
        onDisburseClick={() => { this.setState({ disburseMode: true }) }}
        onDisburseCancelClick={() => { this.setState({ disburseMode: false }) }}
        //
        amountUpdateMode={this.state.amountUpdateMode}
        onAmountUpdateClick={() => { this.setState({ amountUpdateMode: true }) }}
        onAmountUpdateCancelClick={() => { this.setState({ amountUpdateMode: false }) }}
        //
        promoterFundWaived={this.state.promoterFundWaived}
        onWaivePromoterfundClick={() => { this.setState({ promoterFundWaived: true }) }}
        onWaivePromoterfundCancelClick={() => { this.setState({ promoterFundWaived: false }) }}
        //
        onUpdateLoanClick={this.onUpdateLoanClick}
        updateLoanMode={this.state.updateLoanMode}
        onCancelUpdateLoan={() => { this.setState({ updateLoanMode: false }) }}
        //
        onUpdateDepositClick={() => { this.setState({ updateDepositMode: true }) }}
        updateDepositMode={this.state.updateDepositMode}
        onCancelUpdateDeposit={() => { this.setState({ updateDepositMode: false }) }}
        //
        assignedUserMode={this.state.assignedUserMode}
        onAssignedUserClick={() => this.setState({ assignedUserMode: true })}
        onAssignedUserCancel={() => this.setState({ assignedUserMode: false })}
        //
        loanPurposeUpdated={this.state.loanPurposeUpdated}
        onUpdateLoanPurposeClick={() => { this.setState({ loanPurposeUpdated: true }) }}
        onUpdateLoanPurposeCancel={() => { this.setState({ loanPurposeUpdated: false }) }}
        //
        parentLoanUpdated={this.state.parentLoanUpdated}
        onUpdateParentLoanClick={() => { this.setState({ parentLoanUpdated: true }) }}
        onUpdateParentLoanCancel={() => { this.setState({ parentLoanUpdated: false }) }}
        //
        lenderUpdateMode={this.state.lenderUpdateMode}
        onLenderUpdateClick={() => { this.setState({ lenderUpdateMode: true }) }}
        onLenderUpdateCancelClick={() => { this.setState({ lenderUpdateMode: false }) }}
        //
        closedDateUpdateMode={this.state.closedDateUpdateMode}
        onClosedDateUpdateClick={() => { this.setState({ closedDateUpdateMode: true }) }}
        onClosedDateUpdateCancel={() => { this.setState({ closedDateUpdateMode: false }) }}
        //
        closedReasonUpdateMode={this.state.closedReasonUpdateMode}
        onClosedReasonUpdateClick={() => { this.setState({ closedReasonUpdateMode: true }) }}
        onClosedReasonUpdateCancel={() => { this.setState({ closedReasonUpdateMode: false }) }}
        //
        requestDescUpdateMode={this.state.requestDescUpdateMode}
        onUpdateRequestDescClick={() => { this.setState({ requestDescUpdateMode: true }) }}
        onUpdateRequestDescCancel={() => { this.setState({ requestDescUpdateMode: false }) }}
        //
        creditMemoList={this.props.creditMemoList}
        selectedCreditMemo={this.props.selectedCreditMemo}
        generateCreditMemoRequested={this.props.generateCreditMemoRequested}
        onGenerateCreditMemo={this.props.onGenerateCreditMemo}
        onRefreshCreditMemos={this.props.onRefreshCreditMemos}
        onCreditMemoSelect={this.props.onCreditMemoSelect}
        onStartChat={this.props.onStartChat}
        showChatIframe={this.props.showChatIframe}
        onCloseChatIframe={this.props.onCloseChatIframe}
        showCreditMemoResultModal={this.props.showCreditMemoResultModal}
        creditMemoResultMessage={this.props.creditMemoResultMessage}
        creditMemoResultType={this.props.creditMemoResultType}
        onCloseCreditMemoResultModal={this.props.onCloseCreditMemoResultModal}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoans(context)
    // this.getBillList(context, this.props.loan)
  }

  componentDidUpdate(prevProps) {
    let loan = this.props.loan
    if (!loan)
      return
    if (prevProps.loan && prevProps.loan.loanId == loan.loanId)
      return

    let context = this.props.context
    // this.getBillList(context, this.props.loan)
  }

  getLoans(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.loan.accountId}/loans`,
      cacheKey: CacheKeys.AccountLoans(this.props.loan.accountId),
      callback: this.getLoansCallback,
      ttlInSecs: 600
    });
    cacheManager.getObject2(context);
  }

  getLoansCallback = (response) => {
    let loanList = response.loanList.map(loan => ({
      key: loan.loanId,
      value: `${loan.loanRefNum} - ${loan.loanName}`
    }));
    this.setState({ loanList: loanList });
  };

  onStatusUpdateClick = () => {
    this.setState({ statusUpdateMode: true })
  }

  onStatusCancelClick = () => {
    this.setState({ statusUpdateMode: false })
  }

  onUpdateLoanClick = (event) => {
    this.setState({
      updateLoanMode: true
    })
  }
}

export default LoanDetailSF
